import {RWebShare as RShare} from 'react-web-share';
export const RWebShare = RShare;
